<template>
    <div class="app-container">
        <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'80px'" :get-action="queryApi" :serial="serial"
            :selection="selection"
            :before-reset-search="beforeResetSearch"
            @handleSelectionChange="handleSelectionChange"
            @showSetting="SortableTable.show"
            @header-dragend="SortableTable.handleHeaderDragend"
            @header-contextmenu="SortableTable.handleHeaderContextmenu"
        >
        <template v-slot:baseForm>
            <el-col :span="colSpan">
                <el-form-item>
                    <BjSelectLov v-model="cusName" :option-list="customerList" @change="changeCustomer" :placeholder="$t('customerNameText')" />
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item prop="cusCode">
                    <BjInput v-model="queryParams.cusCode" :maxlength="20" :placeholder="$t('billingPage.clientCode')" clearable @keyup.enter.native="handleQuery" />
                </el-form-item>
            </el-col>
            <!-- 选择物流 -->
            <el-col :span="colSpan">
                <el-form-item :label="$t('WarehouseManagement.form.chooseLogistics')" prop="logisticsName">
                    <BjSelectLov v-model="queryParams.logisticsName" :option-list="LogisticsSelectionData"
                    :placeholder="$t('WarehouseManagement.form.chooseLogistics')" />
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item :label="$t('AccountManagementAdd.from')">
                    <BjDateRangePicker v-model="queryParamsTime_create" :placeholder="$t('AccountManagementAdd.ps2')" />
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item prop="isEnable">
                <BjSelectLov
                    v-model="queryParams.isEnable"
                    :option-list="STATUS_ENABLED_NUM"
                    :placeholder="$t('RoleManagement.common.Status')"
                />
                </el-form-item>
            </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="addRate(1)">{{ $t('addText') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column
              v-if="col.prop !== 'bjTableAction'"
              :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
              :prop="col.prop"
              :label="col.label"
              :width="col.width || 'auto'"
              :fixed="col.fixed || false"
              align="center"
              class-name="item"
            >
              <template slot-scope="scope">
                <template v-if="false" />
                <el-tag v-else-if="col.prop === 'isEnable'" :type="scope.row.isEnable ? 'success' : 'info'">
                  {{ $t(STATUS_ENABLED_NUM.bjGet(scope.row.isEnable)) }}
                </el-tag>
                <span v-else-if="col.prop === 'profitMargin'">{{ scope.row.profitMargin }}%</span>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="col.prop === 'bjTableAction'"
              :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
              :prop="col.prop"
              :label="col.label"
              :width="col.width || 'auto'"
              :fixed="col.fixed || 'right'"
              align="center"
            >
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="addRate(2, props.row)">{{ $t('editText') }}</el-button>
                <el-button v-if="!props.row.isEnable" type="text" class="delete-btn" @click="onEnable(props.row)">{{ $t('enableText') }}</el-button>
                <el-button v-if="props.row.isEnable" type="text" class="delete-btn" @click="onDisable(props.row)">{{ $t('disableText') }}</el-button>
                <el-button type="text" @click="showLog(props.row)">{{ $t('logText')}}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 新增/编辑弹窗 -->
      <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import DataForm from './components/DataForm.vue';
  import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';
  import { logisticApi, channelApi } from '@/api';
  import { STATUS_ENABLED_NUM } from '@/utils/constants';
  import orderLog from '@/utils/log.js';
  export default {
    name: 'BusinessLogisticsRateIndex',
    components: {
        DataForm, BjSelectCustomer,
    },
    mixins: [pageMiXin],
    data() {
      return {
        colSpan: 4,
        selection: false,
        queryApi: logisticApi.getLogisticRate,
        STATUS_ENABLED_NUM,
        // 查询参数
        queryParams: {
          cusName: null,
          cusCode: null,
          logisticsName: null,
          startDate: null,
          endDate: null,
          isEnable: null,
        },
        cusName: null,
        LogisticsSelectionData: [],
        queryParamsTime_create: [],
        labelList: [
          { label: this.$t('billingPage.CustomerName'), prop: 'cusName', isCheck: true, disabled: false },
          { label: this.$t('billingPage.clientCode'), prop: 'cusCode', isCheck: true, disabled: false },
          { label: this.$t('WarehouseManagement.form.chooseLogistics'), prop: 'logisticsName', isCheck: true, disabled: false },
          // { label: this.$t('billingPage.Floating'), prop: 'rate', isCheck: true, disabled: false },
          // { label: this.$t('businessLogisticsCompanyBusiness.table.DefaultMarkup'), prop: 'rate', isCheck: true, disabled: false },
          { label: this.$t('businessLogisticsCompanyBusiness.table.ProfitMargin'), prop: 'profitMargin', isCheck: true, disabled: false },
          { label: this.$t('AccountManagementAdd.from'), prop: 'startDate', isCheck: true, disabled: false },
          { label: this.$t('AccountManagementAdd.until'), prop: 'endDate', isCheck: true, disabled: false },
          { label: this.$t('RoleManagement.common.Status'), prop: 'isEnable', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 160 },
        ],
      };
    },
    computed: {},
    watch: {
        queryParamsTime_create(v) {
            this.queryParams.startDate = (v || [])[0];
            this.queryParams.endDate = (v || [])[1];
        },
    },
    created() {
        this.getDataOfSearch();
    },
    mounted() {},
    methods: {
      showLog(row) {
          console.log(row,"row===>");
          
            orderLog(
                this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
                  actionApi:channelApi.getLogPage,
                    defaultQuery: {
                      recordId:row.id,
                      recordType:"LOGISTICS RATE"
                    },
                    columns: [
                        {
                            prop: 'createdName',
                            label: 'BjDialogListConfig.Operator',
                        },
                        {
                            prop: 'creationDate',
                            label: 'BjDialogListConfig.Operationtime',
                        },
                        {
                            prop: 'remark',
                            label: 'BjDialogListConfig.Remarks',
                        },
                    ],
                }),
            );
        },
        // 客户名称选中后 通过方法拿到item里的cusname给后端传参
        changeCustomer(val, item) {
            this.queryParams.cusName = item.cusName;
        },
        // 区分 新增 编辑
        addRate(type, row) {
            type === 1 ? this.$refs.DataForm.show() : this.$refs.DataForm.show(this.$lodash.clone(row));
        },
        // 启用
        onEnable(row) {
          this.$confirm(this.$t('AccountManagement.common.ps4') + this.$t('enableText') + '， ' + this.$t('AccountManagement.common.ps5'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('okText'),
            cancelButtonText: this.$t('cancelText'),
            type: 'warning',
          }).then(() => {
            logisticApi.getLogisticRateSave({
                ...row, isEnable: 1
            }).then(() => {
                this.reFresh();
            });
          });
        },
        // 禁用
        onDisable(row) {
          this.$confirm(this.$t('AccountManagement.common.ps4') + this.$t('disableText') + '， ' + this.$t('AccountManagement.common.ps5'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('okText'),
            cancelButtonText: this.$t('cancelText'),
            type: 'warning',
          }).then(() => {
            logisticApi.getLogisticRateSave({
                ...row, isEnable: 0
            }).then(() => {
                this.reFresh();
            });
          });
        },
        // 组件传参
        batchDeleteApi(API_DATA) {
            console.log('batchDeleteApi', API_DATA);
        },

        // 获取物流下拉信息
        async getDataOfSearch() {
            logisticApi.getLogisticsBusiness({...this.queryParams,enableFlag: true,size:999}).then(res => {
              this.LogisticsSelectionData = res.content.map(item => {
                  return {
                    label: item.name,
                    value: item.name
                  };
              });
            })
        },
        /** 重置按钮操作 */
        beforeResetSearch() {
            this.cusName = null;
            this.queryParams.cusName = null;
            this.queryParamsTime_create = null;
            return new Promise(resolve => {
                resolve();
            });
        },
    },
  };
  </script>
  <style lang="scss" scoped>
  .dialog-custom-class-body-div {
    max-height: calc(85vh - 120px);
    overflow-y: scroll;
  }
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
